import "./App.css";
import "./global.css";
import { BrowserRouter } from "react-router-dom";
import AuthGuard from "./layout/auth-guard";
import Router from "./routes/router";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setlogInUserDetail, setUser } from "./redux/slice/auth/authSlice";
import jwt_decode from "jwt-decode";
import { AUTH_TOKEN, USER_LOG_IN_DETAIL } from "./constants";
import { Toaster } from "react-hot-toast";
import { clearAuthToken, isTokenExpired } from "./helper/utils";

function App() {
  const auth = useSelector((state) => state.auth.user);
  //console.log("auth:", auth);
  const dispatch = useDispatch();
  const token = localStorage.getItem(AUTH_TOKEN);

  useEffect(() => {
    const userlogInDetail = localStorage.getItem(USER_LOG_IN_DETAIL);

    if (token && !isTokenExpired()) {
      dispatch(setUser(jwt_decode(token)));
    } else {
      clearAuthToken();
      dispatch(setUser(null));
    }

    if (userlogInDetail) {
      let parse = JSON.parse(userlogInDetail);
      dispatch(setlogInUserDetail(parse));
      //console.log("userlogInDetail", userlogInDetail);
    }
  }, [dispatch, token]);

  return (
    <>
      <BrowserRouter>
        {/* <Toaster position="top-right" /> */}
        <AuthGuard>
          <Router />
        </AuthGuard>
      </BrowserRouter>
    </>
  );
}

export default App;
